module.exports = __webpack_public_path__ + "media/ko_kr_s2_HaJoon.50b8d6d2.mp3";